import { Phone, MessageSquare, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 overflow-hidden">
      <div className="grain-overlay absolute inset-0 opacity-50 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10 relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400">
              Ready When You Are
            </p>
            <a
              href="tel:9197373526"
              data-testid="footer-phone-link"
              className="mt-4 block font-syne font-extrabold text-5xl sm:text-7xl text-white hover:text-amber-400 transition-colors duration-300 tracking-tight"
            >
              919-737-3526
            </a>
            <p className="mt-4 inline-flex items-center gap-2 text-slate-400 text-sm">
              <Clock size={15} className="text-amber-400" />
              Mon – Sat, 8AM – 6PM · Text anytime
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:9197373526"
              data-testid="footer-call-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-bold px-8 py-4 transition-colors duration-300"
            >
              <Phone size={17} strokeWidth={2.5} /> Call
            </a>
            <a
              href="sms:9197373526?&body=Hi%20P%26H%20Detailing!%20I%27d%20like%20to%20book%20a%20detail."
              data-testid="footer-text-button"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 hover:border-amber-400/60 hover:bg-white/5 text-white font-semibold px-8 py-4 transition-[border-color,background-color] duration-300"
            >
              <MessageSquare size={17} className="text-amber-400" /> Text
            </a>
          </div>
        </div>

        <h2
          data-testid="footer-brand-display"
          className="mt-20 font-syne font-extrabold uppercase text-stroke leading-none tracking-tight text-[16vw] lg:text-[11rem] select-none text-center"
        >
          P&H Detailing
        </h2>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} P&H Mobile Detailing
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            Benson & Clayton, NC — We Come To You
          </p>
        </div>
      </div>
    </footer>
  );
}
